import { isLocal } from '../utils/environment';

export const currentRequests = [];

class RequestHandler {
    constructor (settings) {
        console.log('Request has been loaded');

        this._currentRequestsToThrottle = [];
        this.settings = $.extend(this.settings, {
            platformUrl: '/platform',
            requestTimeout: 10000,
            debug: isLocal()
        }, settings);
    }

    // public

    /**
     * Do a post request
     *
     * @param url
     * @param data
     * @param successCallback
     * @param errorCallback
     */
    post (url, data, successCallback, errorCallback) {
        const deferred = $.Deferred();

        if (!this._requestIsActive(url))
        {
            this._currentRequestsToThrottle.push(url);

            const request = $.ajax({
                type: 'POST',
                url: url,
                data: data,
                dataType: 'json',
                timeout: this.settings.requestTimeout,
                success: (response, textStatus, XMLHttpRequest) => {
                    RequestHandler.success(response, successCallback, errorCallback, deferred, XMLHttpRequest);
                },
                error: (jqXHR, textStatus, error) => {
                    RequestHandler.error(jqXHR, textStatus, error, errorCallback, deferred);
                },
                complete: () => {
                    this._removeRequestFromThrottleList(url);
                }
            });

            currentRequests.push(request);
        }

        return deferred.promise();
    }

    /**
     * Do a get request
     *
     * @param url
     * @param event
     * @param callback
     */
    get (url, event, callback) {
        const deferred = $.Deferred();

        if (!this._requestIsActive(url))
        {
            this._currentRequestsToThrottle.push(url);

            const request = $.ajax({
                type: 'GET',
                url: url,
                dataType: 'json',
                timeout: this.settings.requestTimeout,
                success: (response, textStatus, XMLHttpRequest) => {
                    RequestHandler.success(response, event, callback, deferred, XMLHttpRequest);
                },
                error: (jqXHR, textStatus, error) => {
                    RequestHandler.error(jqXHR, textStatus, error, callback, deferred);
                },
                complete: () => {
                    this._removeRequestFromThrottleList(url);
                }
            });

            currentRequests.push(request);
        }

        return deferred.promise();
    }

    // private

    /**
     *
     * @param request
     */
    _removeRequestFromThrottleList (request)
    {
        this._currentRequestsToThrottle.splice($.inArray(request, this._currentRequestsToThrottle), 1);
    }

    /**
     *
     * @param request
     * @returns {boolean}
     */
    _requestIsActive (request)
    {
        let active = false;

        if (isLocal())
        {
            active = this._currentRequestsToThrottle.indexOf(request) > -1;

            if (active)
            {
                RequestHandler.logRequestWasDenied(request);
            }
        }

        return active;
    }

    // static

    /**
     *
     * @param result
     * @param successCallback
     * @param errorCallback
     * @param deferred
     * @param request
     */
    static success (result, successCallback, errorCallback, deferred, request)
    {
        if (result.errorCode === 1)
        {
            // everything is fine so we can execute the function
            successCallback(result.response);
            deferred.resolve(result.response);
        }
        else
        {
            // we've encountered an error so show correct error message
            const obj = {
                errorCode: result.errorCode,
                errorStatus: result.errorStatus,
                errorMessage: result.message,
                messageData: result.messageData
            };

            errorCallback(obj, result.response, request);
            deferred.reject(obj);
        }

        currentRequests.splice($.inArray(request, currentRequests), 1);
    }

    /**
     *
     * @param request
     * @param textStatus
     * @param error
     * @param errorCallback
     * @param deferred
     */
    static error (request, textStatus, error, errorCallback, deferred)
    {
        // we've encountered an error so show correct error message
        const obj = {
            errorCode: 2,
            errorStatus: 'TransportException',
            errorMessage: 'We\'ve encountered an error, please try again later',
            messageData: []
        };

        if (typeof errorCallback === 'function')
        {
            errorCallback(obj, null, request);
        }

        deferred.reject(obj);

        currentRequests.splice($.inArray(request, currentRequests), 1);
    }

    /**
     *
     * @param request
     */
    static logRequestWasDenied (request)
    {
        console.error('DUPLICATE REQUEST: ' + request);
    }
}

export default RequestHandler;



// WEBPACK FOOTER //
// ./app/src/js/library/RequestHandler.js